import { Activity } from './activity';

export interface WorkLevel {
  id: string;
  title: string;
  year: string;
  language: string;
  originIndia: string;
  isActive: boolean;
  isDeleted: boolean;
  isMaster: boolean;
}

export interface WorkLevelItem {
  map(arg0: (data: any) => { key: any; value: any; text: any; }): unknown;
  id: string;
  title: string;
  year: string;
  language: string;
  originIndia: string;
  isActive: boolean;
  isDeleted: boolean;
  isMaster: boolean;
  items: Activity[];
}

export interface GetWorklevel {
  id: string;
  title: string;
  items: Activity[];
}
export const WorkLevelInitialData = {
  id: '',
  title: '',
  year: '',
  language: '',
  originIndia: '',
  isActive: true,
  isMaster: false,
  isDeleted: false,
};

export interface cloneData {
  title: string;
  type: string;
  element: string;
}
export interface NameInterface {
  title: string;
}
